import ValidateEmailSignupLink from "../components/validateEmailSignupLink/ValidateEmailSignupLink";

export default function ValidateSignupLinkPage() {
  return <ValidateEmailSignupLink />;
}
